<template>
  <el-form ref="ff" v-loading="loading" :model="detail" label-position="top">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="真实姓名" prop="Name" required>
          <el-input v-model="detail.Name" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="手机号码">
          <el-input v-model="detail.Phone" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="登录账号">
          <el-input v-model="detail.Account" :disabled="!!detail.Id" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="到期时间（不填为永久授权）" prop="ExpireDate">
          <el-date-picker style="width: 100%" v-model="detail.ExpireDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="授权角色">
          <el-checkbox-group v-model="detail.Roles">
            <el-checkbox v-for="(item, index) in roleOptions" :key="index" :label="item.Id">{{ item.Name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button type="primary" @click="onSubmit" v-loading.fullscreen.lock="loading">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      userRoles: [],
      detail: this._detail,
      roleOptions: []
    }
  },
  props: {
    _detail: {
      type: Object, default: () => {
        return {
          Roles: []
        }
      }
    },
    layerid: { type: String, default: null }
  },
  created () {
    this.loadRoles()
  },
  methods: {
    //获取数据对象
    loadRoles () {
      this.$apis.system.role.getList().then((res) => {
        this.roleOptions = res
      }).catch(e => {
        this.$message.error(e || "执行错误")
      })
    },
    //提交数据
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true

          //处理数组
          this.$apis.system.user.submit(this.detail).then(res => {
            this.$parent.loadData()
            this.$layer.close(this.layerid)
            this.$message({ message: res || "数据提交成功！", type: "success" })
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
